import { IAction, isType } from '@zaibot/fsa';

import USERGROUP_LOADED from './actions/USERGROUP_LOADED';
import USERGROUP_NOT_LOADED from './actions/USERGROUP_NOT_LOADED';

import { IUsergroup } from '../types';
import USERGROUP_CREATED from './actions/USERGROUP_CREATED';
import USERGROUP_UPDATED from './actions/USERGROUP_UPDATED';
import USERGROUP_INSPECT from './actions/USERGROUP_INSPECT';
import React from 'react';
import USERGROUP_REMOVE from './actions/USERGROUP_REMOVE';
interface IState {
  usergroup: IUsergroup;
  allTenantUsers: boolean;
  inspect: IUsergroup;
}
const emptyState: IState = {
  usergroup: {userIDs:[''], key: '', userId:'', name: '', id: 0} as IUsergroup,
  allTenantUsers: false,
  inspect: {userIDs:[''], key: '', userId:'', name: '', id: 0} as IUsergroup,
};

export const emptyInspectUser = emptyState.inspect;

export const selector = (state: any) => state.usergroup as IState;

export const reducer = (state = emptyState, action: IAction) => {  
  if (isType(action, USERGROUP_NOT_LOADED)) {
    return { ...state };
  }
  if (isType(action, USERGROUP_LOADED)) {
    return { ...state };
  }  
  if (isType(action, USERGROUP_CREATED)) {
    return { ...state };
  }  
  if (isType(action, USERGROUP_UPDATED)) {
    return { ...state };
  }  
  if (isType(action, USERGROUP_INSPECT)) {
    return { ...state, inspect: action.payload.usergroup};
  }    
  if (isType(action, USERGROUP_REMOVE)) {
    return { ...state, remove: action.payload.usergroup};
  }  
  return state; 
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/usergroup/reducer.tsx